export const publish = async <T>(topic: string, payload?: T): Promise<boolean> => {
  const publishUrl = `/xhr/mercure/${topic}/publish`;
  const options = { method: 'POST' } as RequestInit;
  if (payload) {
    options.body = JSON.stringify(payload);
  }
  const { status } = await fetch(publishUrl, options);
  return status === 204;
};

export const getSubscribeToken = async (topic: string): Promise<string | null> => {
  const authorizeUrl = `/xhr/mercure/${topic}/authorize`;
  const response = await fetch(authorizeUrl);
  const { token } = await response.json();
  return token;
};
